// API client for Campaign Links (/api/campaign-links, sia-backend CampaignLinkController).
//
// Envelope: { data, isError, statusCode, errorMessage }. Allowed roles: ADMIN, ALL_FUNCTIONS, MARKETING.
//   GET    /api/campaign-links?search&source&medium&status&page&size
//          status: ACTIVE (default) | DELETED | ALL; search matches the campaign name.
//          Returns a page { content, page, size, totalElements, totalPages, hasNext }, last updated first.
//   GET    /api/campaign-links/filters      { sources, mediums } already in use
//   GET    /api/campaign-links/{id}         one campaign
//   POST   /api/campaign-links              create; the server builds the link itself
//                                           (409 if an active campaign already has the same link)
//   PUT    /api/campaign-links/{id}         update the campaign in place; the server rebuilds the link
//   DELETE /api/campaign-links/{id}         soft delete
//   POST   /api/campaign-links/{id}/restore restore (409 if an active campaign now has the same link)
// The backend drops empty fields from responses (Jackson NON_EMPTY), e.g. customParams: [] is omitted.
import api from "../axiosInstance";

export { apiErrorMessage } from "./assessmentHierarchy";

const BASE = "/api/campaign-links";

const unwrap = (res) => res.data?.data;

export const listCampaignLinks = (params) => api.get(BASE, { params }).then(unwrap);

export const getCampaignLinkFilters = () => api.get(`${BASE}/filters`).then(unwrap);

export const getCampaignLink = (id) => api.get(`${BASE}/${id}`).then(unwrap);

export const createCampaignLink = (body) => api.post(BASE, body).then(unwrap);

export const updateCampaignLink = (id, body) => api.put(`${BASE}/${id}`, body).then(unwrap);

export const deleteCampaignLink = (id) => api.delete(`${BASE}/${id}`).then(unwrap);

export const restoreCampaignLink = (id) => api.post(`${BASE}/${id}/restore`).then(unwrap);
